<template>
  <div class="contact ld-background ld-left-slide ld-scroll-y">
    <div class="ld-height-100 px-4">
      <v-row class="ld-height-50 pt-3">
        <v-col xs="12">
          <div class="ld-height-100 text-xs-center" :class="{'pr-4' : screenWidthSmall}">
            <iframe style="user-select: text;" width="100%" height="100%" frameborder="0" scrolling="no" marginheight="0"
                    marginwidth="0" src="https://maps.google.com/maps?f=q&source=s_q&hl=en&geocode=&q=lollicup+denver&aq=&sll=38.997934,-105.550567&sspn=5.710579,6.580811&t=h&ie=UTF8&hq=lollicup+denver&ll=39.687814,-104.941892&spn=0.011047,0.014291&z=16&iwloc=A&cid=17393576260634331111&output=embed">
            </iframe>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col xs="12">
          <div>
            <span class="font-weight-bold">
              Contact Information:
            </span>
          </div>
          <div class="ld-contact-text">
            Lollicup Denver Tea Zone
          </div>
          <div class="ld-contact-text">
            1589 S. Colorado Blvd.
          </div>
          <div class="ld-contact-text">
            Denver, CO 80222
          </div>
          <div class="ld-contact-text">
            Phone: 303-504-6022
          </div>
        </v-col>
      </v-row>
      <v-row v-if="showHoursOfOperationAdjusted">
        <v-col xs="12">
          <v-row>
            <v-col xs="12">
              <div>
                <span class="font-weight-bold">Hours of Operation (adjusted):</span>
              </div>
              <div>
                <span class="font-italic">(Adjusted hours due to COVID-19)</span>
              </div>
            </v-col>
          </v-row>
          <v-row v-for="(item) in hoursOfOperationAdjusted">
            <v-col class="py-0" cols="12" xs="4" sm="3" lg="2">
              <div>
                <span class="font-weight-bold">{{item.dayOfWeek}}</span>
              </div>
            </v-col>
            <v-col class="py-0" cols="12" xs="8" sm="9" lg="10">
              <div>
                <span>{{item.hours}}</span>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col xs="12">
          <v-row>
            <v-col xs="12">
              <div>
                <span class="font-weight-bold">Summer Hours of Operation:</span>
              </div>
            </v-col>
          </v-row>
          <v-row v-for="(item) in hoursOfOperationNormal">
            <v-col class="py-0" cols="12" xs="4" sm="3" lg="2">
              <div>
                <span class="font-weight-bold">{{item.dayOfWeek}}</span>
              </div>
            </v-col>
            <v-col class="py-0" cols="12" xs="8" sm="9" lg="10">
              <div>
                <span>{{item.hours}}</span>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'contactComponent',

    props: ['screenWidthSmall'],

    data() {
      return {
        hoursOfOperationAdjusted: [
          {
            dayOfWeek: 'Monday',
            hours: '11:00 A.M. - 8:00 P.M.'
          },
          {
            dayOfWeek: 'Tuesday',
            hours: '11:00 A.M. - 8:00 P.M.'
          },
          {
            dayOfWeek: 'Wednesday',
            hours: '11:00 A.M. - 8:00 P.M.'
          },
          {
            dayOfWeek: 'Thursday',
            hours: '11:00 A.M. - 8:00 P.M.'
          },
          {
            dayOfWeek: 'Friday',
            hours: '11:00 A.M. - 8:00 P.M.'
          },
          {
            dayOfWeek: 'Saturday',
            hours: '11:00 A.M. - 8:00 P.M.'
          },
          {
            dayOfWeek: 'Sunday',
            hours: '12:00 P.M. - 8:00 P.M.'
          }
        ],
        hoursOfOperationNormal: [
          {
            dayOfWeek: 'Monday',
            hours: '11:00 A.M. - 9:00 P.M.'
          },
          {
            dayOfWeek: 'Tuesday',
            hours: '11:00 A.M. - 9:00 P.M.'
          },
          {
            dayOfWeek: 'Wednesday',
            hours: '11:00 A.M. - 9:00 P.M.'
          },
          {
            dayOfWeek: 'Thursday',
            hours: '11:00 A.M. - 9:00 P.M.'
          },
          {
            dayOfWeek: 'Friday',
            hours: '11:00 A.M. - 10:00 P.M.'
          },
          {
            dayOfWeek: 'Saturday',
            hours: '11:00 A.M. - 10:00 P.M.'
          },
          {
            dayOfWeek: 'Sunday',
            hours: '12:00 P.M. - 8:00 P.M.'
          }
        ],
        showHoursOfOperationAdjusted: false
      };
    }
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/contact_component.vue